import axios from "axios";
import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
const TimeAddModal = (props) => {
  const { NewCoinId, setupdateData } = props;

  const [dataVulue, setDataVulue] = useState({});
  const [errorMessage, setErrorMessage] = useState([]);
  const refSubmitDis = useRef();

  const handleSubmitData = (event) => {
    event.preventDefault();
    refSubmitDis.current.setAttribute("disabled", true);
    const config = {
      headers: {
        "content-type": "application/json",
      },
    };
    axios
      .put(
        `https://api.wlfmobile.com/api/admin/new/coin/date/update/${NewCoinId}`,
        dataVulue,
        config
      )
      .then((response) => {
        event.target.reset();
        toast.success(`${response?.data.message}`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setDataVulue();
        setupdateData(response?.data);
        props.onHide();
        refSubmitDis.current.removeAttribute("disabled");
      })
      .catch((error) => {
        refSubmitDis.current.removeAttribute("disabled");
        if (error?.response?.data?.errors) {
          setErrorMessage(error?.response?.data?.errors);
        } else {
          setErrorMessage(error?.response?.data);
        }
      });
  };

  const handleInputBlur = (event) => {
    const value = event.target.value;
    const field = event.target.name;
    const newData = { ...dataVulue };
    newData[field] = value;
    setDataVulue(newData);
  };

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Update Time
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-lg-12 col-md-12 mb-30">
            <div className="card">
              <div className="card-body">
                <form onSubmit={handleSubmitData}>
                  <div className="row">
                    <div className="col-md-12 ">
                      <div className="form-group">
                        <label htmlFor="heading" className="required">
                          Update Expired Time
                        </label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          name="expired_date"
                          onBlur={handleInputBlur}
                          placeholder="expired_date"
                          id="heading"
                          min={new Date().toISOString().split("T")[0]}
                        />
                        {errorMessage?.expired_date && (
                          <span className="text-danger pt-2">
                            {errorMessage?.expired_date?.msg}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-12 ">
                      <div className="form-group">
                        <label htmlFor="heading" className="required">
                          Update upcoming Time
                        </label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          name="upcoming_time"
                          onBlur={handleInputBlur}
                          placeholder="upcoming_time"
                          id="heading"
                          min={new Date().toISOString().split("T")[0]}
                        />
                        {errorMessage?.upcoming_time && (
                          <span className="text-danger pt-2">
                            {errorMessage?.upcoming_time?.msg}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <button
                      ref={refSubmitDis}
                      type="submit"
                      className="btn btn-primary w-100 h-45"
                    >
                      update
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default TimeAddModal;
